import { Trans } from '@lingui/react/macro'

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@jotta/ui/AlertDialog'
import SvgWarningOctagon from '@jotta/ui/SvgWarningOctagon'

export function MixedBackupRestoreDialog({
  onClose,
  onContinue,
}: {
  onClose: () => void
  onContinue: () => void
}) {
  return (
    <AlertDialog
      open
      onOpenChange={nextOpen => {
        if (!nextOpen) {
          onClose()
        }
      }}
    >
      <AlertDialogContent className="sm:max-w-[420px]">
        <AlertDialogHeader>
          <div className="flex items-center gap-3">
            <span className="flex size-10 p-2.5 shrink-0 items-center justify-center rounded-full bg-surface-container-lowest">
              <SvgWarningOctagon />
            </span>
            <AlertDialogTitle className="whitespace-normal text-left">
              <Trans>Restore is unavailable for files from backup</Trans>
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-left">
            <Trans>
              Some files can't be restored because they came from Backup.
              They'll be skipped. Continue?
            </Trans>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>
            <Trans>Cancel</Trans>
          </AlertDialogCancel>
          <AlertDialogAction onClick={onContinue}>
            <Trans>Continue</Trans>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
